/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InPersonTrainingStatus;

(function (InPersonTrainingStatus) {
  InPersonTrainingStatus["TO_BE_SCHEDULED"] = "to_be_scheduled";
  InPersonTrainingStatus["BOOKED"] = "booked";
  InPersonTrainingStatus["CONFIRMED"] = "confirmed";
  InPersonTrainingStatus["COMPLETED"] = "completed";
  InPersonTrainingStatus["RESCHEDULED"] = "rescheduled";
  InPersonTrainingStatus["CANCELLED_BY_BROKER"] = "cancelled_by_broker";
  InPersonTrainingStatus["CANCELLED_INTERNALLY"] = "cancelled_internally";
})(InPersonTrainingStatus || (InPersonTrainingStatus = {}));